import {Status} from '../reusables/status';
import {LotteryStatusType} from '../../enum';
import {LotteryStatusTranslationService} from 'src/app/shared/translations';

/**
 * Blueprint for the tixx select status
 */
export class TixxSelectStatus {
  public value: string;
  public status: Status;
  public inTimeRange: boolean;
  public statuses: Array<any> = [
    {value: LotteryStatusType.DRAFT, status: this.t.i18nDraft, class: 'esf-tag--info'},
    {value: LotteryStatusType.ACTIVATED, status: this.t.i18nActivated, class: 'esf-tag--success'},
    {value: LotteryStatusType.EDIT, status: this.t.i18nEdit, class: 'esf-tag--warning'},
    {value: LotteryStatusType.INTERNAL, status: this.t.i18nInternal, class: 'esf-tag--warning'},
    {value: LotteryStatusType.EXECUTION, status: this.t.i18nExecution, class: 'esf-tag--warning'},
    {value: LotteryStatusType.COMPLETED, status: this.t.i18nCompleted, class: 'esf-tag--alert'},
  ];

  constructor(status: any, private t: LotteryStatusTranslationService) {
    this.value = status.name;
    this.status = this.getFullStatus(status.name);
    this.inTimeRange = status.inTimeRange;
  }

  /**
   * Retrieves the status
   */
  public getFullStatus(status: string): any {
    const fullStatus = this.statuses.find(el => status === el.value);
    return fullStatus ? new Status(fullStatus) : status;
  }

  get translatedCustomerStatus(): string {
    return this.status.status;
  }

  get statusCssClass(): any {
    return this.status.class;
  }
}
